import React from "react";
import CommonModal from "../../../../../../Modals/CommonModal";
import Button from "../../../../../../Elements/Button";

const LightBoxExtendWarningModal = ({ openModal, closeModal, onConfirm, onRevert }) => {
    const handleYes = () => {
        onConfirm();
        closeModal(false);
    };

    const handleNo = () => {
        onRevert();
        closeModal(false);
    };

    return (
        <CommonModal
            title={"Lightbox Size Warning"}
            modalStatus={openModal}
            changeActiveStatus={closeModal}
            classList="header-profile-modal-wrapper alert-modal"
            showFooter={false}
            centered
        >
            <div className="clone-modal">
                <div className="mb-2">
                    This lightbox is larger than the current browser window. <br />
                    Click "Yes" to keep this size, or "No" to revert to the previous size.
                </div>
                <div className="kdf-btn mt-3">
                    <Button
                        text={'No'}
                        classList={"alert"}
                        addonClass={'me-1 px-2'}
                        onClick={handleNo}
                    />
                    <Button
                        text={'Yes'}
                        classList={"success"}
                        type="submit"
                        addonClass={'px-2 common-modal-yes-button'}
                        onClick={handleYes}
                    />
                </div>
            </div>
        </CommonModal>
    );
};

export default LightBoxExtendWarningModal;
